import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: '',
    component: HomeView,
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home",  */ '../views/pages/home.vue')
      },
      {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "home",  */ '../views/pages/home.vue')
      },
      {
        path: '/about',
        name: 'about',
        component: () => import(/* webpackChunkName: "about",  */ '../views/pages/about.vue')
      },
      {
        path: '/productCenter',
        name: 'productCenter',
        component: () => import(/* webpackChunkName: "productCenter",  */ '../views/pages/productCenter.vue')
      },
      {
        path: '/rdCenter',
        name: 'rdCenter',
        component: () => import(/* webpackChunkName: "rdCenter",  */ '../views/pages/rdCenter.vue')
      },
      {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import(/* webpackChunkName: "contactUs",  */ '../views/pages/contactUs.vue')
      },
      {
        path: '/news',
        children: [{}],
        component: () => import(/* webpackChunkName: "loadRouter",webpackPreload: true */ '../views/pages/news.vue'),
        children: [
          {
            path: '/news/newsList',
            name: 'newsList',
            component: () => import(/* webpackChunkName: "newsList",webpackPreload: true */ '../views/pages/newsList.vue')
          },
          {
            path: '/news/newsDetails',
            name: 'newsDetails',
            component: () => import(/* webpackChunkName: "newDetails",webpackPreload: true */ '../views/pages/newDetails.vue')
          }
        ]
      },
      {
        path: '/solution',
        name: 'solution',
        component: () => import(/* webpackChunkName: "solution",  */ '../views/pages/solution.vue')
      }
    ]
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
];

const router = new VueRouter({
  mode: 'history', // 设置为 history 模式
  base: process.env.BASE_URL,
  routes
});

export default router;
